import { useEffect, useState } from 'react';

import PaymentHeader from '../Payment/components/PaymentHeader/index';
import {
  Container,
  Form,
  FormRow,
  InputLabel,
  InputText,
  InputWrapper,
  ErrorRow,
  Error,
} from '../Payment/Payment.styles';

import {
  Margin,
  ActionRow,
  SubmitBtn,
  LabelDescription,
  CancelBtn,
  RadioPrimary,
  RadioGroupPrimary,
} from './Inspections.styles';

import { SpinnerWhite } from '../../styles/Generic.styles';

import Inspection from '../../models/inspection.entity';
import inputMaskService from '../../services/input-mask.service';
import storageService from '../../services/storage.service';
import userTransactionService from '../Payment/services/user-transaction.service';
import { useHistory } from 'react-router';
import PlateInfo from '../../models/plate-info.entity';
import WhatsAppButton from '../Home/components/WhatsAppButton';
import { LocalStoreKeysEnum } from '../../models/enums/localstore-keys.enum';
import { InspectionTypeEnum } from '../../models/enums/inspection-type.enum';
import whitelabelService from '../../services/whitelabel/whitelabel.service';
import { FormControlLabel } from '@mui/material';

const InspectionComponent = () => {
  const history = useHistory();
  const [inspection, setState] = useState<Inspection>(new Inspection());
  const [plateInfo, setPlateInfo] = useState<PlateInfo>(new PlateInfo());
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [documentType, setDocumentType] = useState<string>('cpf');

  const whitelabelCompany = whitelabelService
    .getWBDataCompany();

  const isSicredi = whitelabelCompany
    .workspace === 'vistoriasicredi';

  const goToSummary = () => {
    history.push('summary');
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setState((prevState: any) => ({
      ...prevState,
      [name]: inputMaskService.getMaskedValue(name, value)
    }));
  };

  const handleValidation = () => {
    setErrors([]);
    let formIsValid = true;
    const formErrors: string[] = [];

    if (!inspection.name) {
      formIsValid = false;
      formErrors.push('O campo Nome é obrigatório');
    }

    if (!inspection.cellphone) {
      formIsValid = false;
      formErrors.push('O campo Telefone é obrigatório');
    }

    if (!inspection.email) {
      formIsValid = false;
      formErrors.push('O campo E-mail é obrigatório');
    }

    if (!isSicredi && !inspection.cpf) {
      formIsValid = false;
      formErrors.push('O campo CPF é obrigatório');
    }

    if (isSicredi && (documentType === 'cpf' && !inspection.cpf)) {
      formIsValid = false;
      formErrors.push('O campo CPF é obrigatório');
    }

    if (isSicredi && (documentType === 'cnpj' && !inspection.cnpj)) {
      formIsValid = false;
      formErrors.push('O campo CNPJ é obrigatório');
    }

    if (isSicredi && !inspection.notes) {
      formIsValid = false;
      formErrors.push('O campo Grupo e cota é obrigatório');
    }

    setErrors(formErrors);
    return formIsValid;
  };

  const createTransaction = () => {
    setLoading(true);

    if (!handleValidation()) {
      setLoading(false);
      return;
    }

    inspection.plate = plateInfo.plate;
    inspection.chassis = plateInfo.chassis;

    userTransactionService.create(inspection, isSicredi, documentType)
      .then((result) => {
        const { data } = result.data;

        const transaction = new Inspection(inspection);
        transaction.transactionId = data.id;
        storageService.setObject('inspection', transaction);
        setState(transaction);

        goToSummary();
      })
      .catch((error) => {
        const requestErrors: string[] = [];

        const errorKeys = Object.keys(error);
        errorKeys.forEach((key) => {
          requestErrors.push(error[key][0]);
        });
        setErrors(requestErrors);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const localInspection: any = storageService.getObject('inspection');
    const storagedLocalInspection = storageService.getObject('plateInfo');
    const inspectionType = localStorage.getItem(LocalStoreKeysEnum.INSPECTION_TYPE_KEY);

    if ((inspectionType === InspectionTypeEnum.VEHICLE) && !storagedLocalInspection) {
      history.push('/');
    }

    if (localInspection) {
      setState(new Inspection(localInspection));
    }

    setPlateInfo(storagedLocalInspection);

    setErrors([]);
    // eslint-disable-next-line
  }, []);

  const goToVehicleIdentifier = () => {
    history.push('plate-confirmation');
  };

  return (
    <Container>
      <PaymentHeader />
      <Margin />
      <Form>
        <InputWrapper>
          <InputLabel>Nome Completo</InputLabel>
          <InputText
            type="text"
            onChange={handleChange}
            name="name"
            value={inspection.name}
            data-testid="input-name"
          />
        </InputWrapper>
        <InputWrapper>
          <InputLabel>E-mail</InputLabel>
          <InputText
            type="email"
            onChange={handleChange}
            name="email"
            value={inspection.email}
            placeholder="usuário@email.com"
            data-testid="input-email"
          />
        </InputWrapper>
        <FormRow>
          <InputWrapper>
            <InputLabel>
              Celular
            </InputLabel>
            <InputText
              type="tel"
              onChange={handleChange}
              name="cellphone"
              value={inspection.cellphone}
              maxLength="15"
              placeholder="(__)_____-____"
              data-testid="input-phone"
            />
            <LabelDescription>A vistoria será enviada para este número</LabelDescription>
          </InputWrapper>
          {!isSicredi && (
            <InputWrapper>
              <InputLabel>CPF</InputLabel>
              <InputText
                type="text"
                onChange={handleChange}
                name="cpf"
                value={inspection.cpf}
                maxLength="14"
                placeholder="___.___.___-__"
                data-testid="input-cpf"
              />
            </InputWrapper>
          )}
          {isSicredi && (
            <InputWrapper>
              <InputLabel>Grupo e cota</InputLabel>
              <InputText
                type="text"
                onChange={handleChange}
                name="notes"
                value={inspection.notes}
                placeholder="Informe o grupo e a cota"
                data-testid="input-notes"
              />
            </InputWrapper>
          )}
        </FormRow>
        {isSicredi && (
          <FormRow>
            <RadioGroupPrimary
              row
              name="documentType"
              value={documentType}
              onChange={(e: any) => setDocumentType(e.target.value)}
              style={{ paddingTop: '10px', paddingBottom: '10px' }}
            >
              <FormControlLabel
                value="cpf"
                control={<RadioPrimary color="primary" />}
                label="CPF"
              />
              <FormControlLabel
                value="cnpj"
                control={<RadioPrimary color="primary" />}
                label="CNPJ"
              />
            </RadioGroupPrimary>
          </FormRow>
        )}
        {isSicredi && (
          <FormRow>
            {documentType === 'cpf' && (
              <InputWrapper>
                <InputLabel>CPF</InputLabel>
                <InputText
                  type="text"
                  onChange={handleChange}
                  name="cpf"
                  value={inspection.cpf}
                  maxLength={14}
                  placeholder="___.___.___-__"
                  data-testid="input-cpf"
                  style={{ width: '60%' }}
                />
              </InputWrapper>
            )}
            {documentType === 'cnpj' && (
              <InputWrapper>
                <InputLabel>CNPJ</InputLabel>
                <InputText
                  type="text"
                  onChange={handleChange}
                  name="cnpj"
                  value={inspection.cnpj}
                  maxLength={18}
                  placeholder="__.___.___/____-__"
                  data-testid="input-cnpj"
                  style={{ width: '60%' }}
                />
              </InputWrapper>
            )}
          </FormRow>
        )}
        {(errors.length > 0) && (
          <ErrorRow>
            {errors && errors.map((error: string, index) => (
              <Error key={index}>{error}</Error>
            ))}
          </ErrorRow>
        )}
        <ActionRow>
          <SubmitBtn
            disabled={loading}
            onClick={() => { createTransaction(); }}
            data-testid="submit-btn"
          >
            {loading && (
              <SpinnerWhite />
            )}
            {!loading && (
              <>Continuar</>
            )}
          </SubmitBtn>
          <CancelBtn onClick={() => { goToVehicleIdentifier() }}>
            Voltar
          </CancelBtn>
        </ActionRow>
      </Form>
      <WhatsAppButton />
    </Container>
  );
};

export default InspectionComponent;
